import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import { Box, Stack, Typography } from "@mui/material";

import { ShipmentQuestionActionsMenu } from "components/ShipmentQuestionActionsMenu";
import { useAuthContext } from "hooks";
import { ISOStringToLocalReadableTimestamp } from "utils";

import type { UserQAInfo } from "types/shipments/qa";

interface QuestionAuthorProps {
  questionId: number;
  timestamp: string;
  userInfo: UserQAInfo | null;
}

export function QuestionAuthor(props: QuestionAuthorProps) {
  const { user } = useAuthContext();
  const { questionId, timestamp, userInfo } = props;

  let questionAuthorName = "CARRIER";

  if (userInfo) {
    if (userInfo.user_id === user?.id) {
      questionAuthorName = "You";
    } else {
      questionAuthorName = `${userInfo.first_name} ${userInfo.last_name} from ${userInfo.company_name}`;
    }
  }

  return (
    <Stack direction="row" py={1} spacing={3}>
      <Stack direction="row" spacing={1} alignItems="center">
        <PersonIcon />
        <Typography>{questionAuthorName}</Typography>
      </Stack>
      <Stack direction="row" spacing={1} alignItems="center">
        <AccessTimeIcon />
        <Typography variant="body1">
          {ISOStringToLocalReadableTimestamp(timestamp)}
        </Typography>
      </Stack>
      {!userInfo && (
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end" }}>
          <ShipmentQuestionActionsMenu questionId={questionId} />
        </Box>
      )}
    </Stack>
  );
}
